import { AutocompleteProps as MuiAutocompleteProps, Autocomplete as MuiAutocomplete, TextField, AutocompleteChangeReason, AutocompleteInputChangeReason, Typography } from "@mui/material";

type LightOnMuiAutocompleteProps<T> = Omit<MuiAutocompleteProps<
  T | string,
  undefined,
  boolean | undefined,
  boolean | undefined
>, "onChange"|"inputValue"|"onInputChange"|"renderInput"|"sx">;


interface AutocompleteProps extends LightOnMuiAutocompleteProps<GoogleSearchItemResult> {
  label?: string;
  value: string;
  onChange: (v: string, placeId?:string) => void;
  error?: boolean;
  errorMessage?: string;
  placeholder?: string;
}

export interface GoogleSearchItemResult {
  description:string;
  place_id:string
}

export function Autocomplete({ 
    placeholder, 
    label, 
    value, 
    onChange, 
    error, 
    errorMessage, 
    style,
    className,
    freeSolo = true,
    filterOptions,
    ...props }: AutocompleteProps
) {

  function handleOnChange(
    _: React.SyntheticEvent<Element, Event>,
    value: GoogleSearchItemResult | string | null,
    reason: AutocompleteChangeReason
  ) {

    if (typeof value ===  'object' && value !== null) {
      switch (reason) {
        case "selectOption": return onChange(value.description,value.place_id);
        case "clear": return onChange("");
      }
    }

    switch (reason) {
      case "selectOption":
      case "blur":
        return onChange(value?.toString() || "");
      case "clear": return onChange("");
    }
  }

  function handleOnInputChange(    
      _: React.SyntheticEvent,
      value: string,
      __: AutocompleteInputChangeReason)
  {
    onChange(value);
  }

  const defaultFilterOptions = (
    options: (GoogleSearchItemResult | string)[],
    state: { inputValue: string }
  ) => {
    const query = (state.inputValue || value || "").trim().toLowerCase();
    if (!query) return options;
    const tokens = query.split(/\s+/).filter(Boolean);
    return options.filter((option) => {
      const optionLabel = (typeof option === "string" ? option : option.description || "").toLowerCase();
      return tokens.every((token) => optionLabel.includes(token));
    });
  };

  return (
    <div className={props.fullWidth ? "w-full " : "" + className || ""} style={style}>
      <MuiAutocomplete
        freeSolo={freeSolo}
        autoHighlight
        renderInput={(params) => <TextField {...params} label={label} placeholder={placeholder} />}
        inputValue={value}
        getOptionLabel={(option) => {
          if (typeof option === 'string') return option;
          return option.description || "";
        }}
        filterOptions={filterOptions || defaultFilterOptions}
        onInputChange={handleOnInputChange}
        onChange={handleOnChange}
        {...props}
      />
      {!error ? null : <Typography color="error" variant="caption">{errorMessage}</Typography>}
    </div>
  );
}
